/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Email/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Email({
  children,
  viewPath = "/DesignSystem/DataVaxiomInsuranceBillingCenter/Email",
  isInvalid,
  onChange
  
}) {
let billingCenterContactEmailAddressValueData = fromData.useDataValue({ viewPath,
context: 'billing_center',
path: 'contact_email.address',
})
let billingCenterContactEmailAddressIsValidData = fromData.useDataIsValid({ viewPath,
context: 'billing_center',
path: 'contact_email.address',
validate: fromValidate.email,
})
let billingCenterContactEmailAddressChangeData = fromData.useDataChange({ viewPath,
context: 'billing_center',
path: 'contact_email.address',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="billing_center.contact_email.address"
 validate="/Data/validate.js email"
 invalid={!billingCenterContactEmailAddressIsValidData}
 value={billingCenterContactEmailAddressValueData}
 onChange={billingCenterContactEmailAddressChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Email Address"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}